<template>
  <div>
    <div class="box">
      <div class="content">
        <p class="title">{{ info.listTitle }}</p>
        <div class="content_box" v-html="info.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDetail } from '@/api/detail';

export default {
  data() {
    return {
      id: '',
      info: {},
    };
  },
  async created() {
    const { id } = this.$route.query;
    this.id = id;
    const params = { id: this.id };
    const res = await getDetail(params);
    this.info = res.data;
    this.info.content = this.info.content.replace(
      /<img/g,
      "<img preview='0' title='点击查看大图' class='click'",
    );
  },
  methods: {},
};
</script>
<style scoped lang="scss">
/* PC端样式 */
* {
  margin: 0;
  padding: 0;
}
.box {
  width: 100vw;
  height: 100vh;
  line-height: 26px;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  .content {
    width: 85%;
    margin: 0 auto;
    padding: 20px 20px 50px 20px;
    line-height: 26px;

    .title {
      font-size: 18px;
      margin-bottom: 20px;
      text-align: center;
      font-weight: 600;
    }
  }
}

/* 移动端样式 */
@media all and (max-width: 768px) {
  /* 使用vw/vh单位代替像素单位 */
  .box {
    width: 100vw;
    height: 100vh;
    font-size: 0.18rem;
    line-height: 0.26rem;
    font-size: 0.16rem;
    font-family: "Microsoft YaHei";
  }
}
</style>

<style lang="scss">
.content_box img {
  /* 设置图片的显示方式 */
  object-fit: contain; // 缩放并裁剪图片以填充容器
  max-width: 100%; // 图片最大宽度不超过容器宽度
  height: 40%;
  max-height: 100%; // 图片最大高度不超过容器高度
}
</style>
